import { socialCrawlerApiClient } from '../client';
import statusMockData from '../../containers/UrlFinderStatus/status-mock-data';

export function search(term) {
  return socialCrawlerApiClient
    .get('/entity/search', {
      params: {
        searchTerm: term,
      },
    })
    .then(({ data }) => data);
}

export function getListing(data) {
  return socialCrawlerApiClient
    .post('/entityList', data)
    .then((res) => res.data);
}

export function getDetails(entityId) {
  return socialCrawlerApiClient
    .get('/entityDetails', {
      params: {
        entityId,
      },
    })
    .then(({ data }) => data);
}

export function triggerUrlFinder(data) {
  return socialCrawlerApiClient.post('/find/url', data);
}

export function triggerUrlFinderByCsv(data) {
  return socialCrawlerApiClient.post('/find/url/csv-file', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function getUrlFinderStatus(data) {
  return Promise.resolve(statusMockData);
  // return socialCrawlerApiClient
  //   .post('/trigger/status', data)
  //   .then((res) => res.data);
}

export function verify(entityId) {
  return socialCrawlerApiClient
    .get(`/verify/entity/${entityId}`)
    .then(({ data }) => data);
}

export function getClientDetails(entityId) {
  return socialCrawlerApiClient
    .get('/entityClientDetails', {
      params: {
        entityId,
      },
    })
    .then(({ data }) => data);
}
